module.exports = __webpack_public_path__ + "static/tracking-dbbd553994c4f40404a5c50a966253b0.png";